import React, {useEffect, useRef, useState} from "react";
import { useInView } from 'react-intersection-observer';
import { AnimatePresence, motion } from "framer-motion";

const MobileControls = ({isMuted, handleSoundClick, handleFullscreenClick, scrollRef, isFullscreen, isVideoPlaying}) => {
    const positionRef = useRef(null);
    const [startedInView, setStartedInView] = useState(null);
    const { ref: secondarySecRef, inView: secondMetaInView } = useInView({
        triggerOnce: true, // Trigger only once when entering the viewport
        threshold: 0.5, // Trigger when 50% of the element is in view (adjust this based on your needs)
    });

    const mobVariants = {
        initial: {
            opacity: 1
        }, animate: {
            opacity: 1,
            transition: {
                duration: 1,
                delay: 0.6,
                ease: "easeIn"
            }
        }, exit: {
            opacity: 0
        }
    }

    useEffect(() => {
        if(scrollRef.current){
            if(secondMetaInView){
                const style = window.getComputedStyle(scrollRef.current);
                // Extract the transform property
                const transform = style.transform;

                if (transform && transform !== 'none') {
                    // Parse the translateY value
                    const matrix = transform.match(/matrix.*\((.+)\)/);
                    if (matrix) {
                    const values = matrix[1].split(', ');
                    const translateY = values[5]; // translateY is the 6th value in a matrix(1, 0, 0, 1, tx, ty)
                        if(translateY > -1){
                            setStartedInView(true);
                        }else setStartedInView(false);
                    }
                }
            }
        }
    }, [secondMetaInView, scrollRef])
    return(
        <>
            <motion.div 
                className="mob_controls__wrapper"
                initial="initial"
                animate="animate"
                exit="exit"
            >
                <>
                    
                    <motion.div
                        className="mob_sound" 
                        onClick={handleSoundClick}
                        style={{
                            position: "relative"
                        }}
                        variants={mobVariants} 
                    >
                        <AnimatePresence mode="wait">
                            {
                                isVideoPlaying &&
                                    <motion.span 
                                    key="mob-close-opt"
                                    style={{
                                        display: "inline-block"
                                    }}
                                    initial={{
                                        opacity: 0,
                                        transform: "translateY(100%)"
                                    }} animate={{
                                        opacity: 1,
                                        transform: "translateY(0%)",
                                        transition: {
                                            duration: 1.5,
                                            ease: [0.16, 1, 0.3, 1]
                                        }
                                    }} exit={{
                                        opacity: 0,
                                        transition: {
                                            delay: 0.25
                                        },
                                        transform: "translateY(100%)"
                                    }}
                                >SOUND</motion.span>
                            }
                        </AnimatePresence>
                        <div 
                            className={`strikethrough ${isMuted && isVideoPlaying ? "strike-active" : ""}`}
                            style={{
                                transitionDuration: !isVideoPlaying ? "0.25s" : "1s"
                            }}    
                        />
                    </motion.div>
                    <motion.div 
                        ref={positionRef}
                        className="mob_fullscreen" 
                        onClick={handleFullscreenClick}
                        variants={mobVariants}
                    >
                        <AnimatePresence mode="wait">
                        {
                            !isFullscreen ?
                                <motion.span 
                                    initial={{
                                        opacity: 0,
                                        transform: "translateY(100%)"
                                    }} animate={{
                                        opacity: 1,
                                        transform: "translateY(0%)",
                                        transition: {
                                            delay: 0.75,
                                            duration: 1.5,
                                            ease: [0.16, 1, 0.3, 1]
                                        }
                                    }} exit={{
                                        opacity: 1,
                                        transform: "translateY(100%)"
                                    }}
                                    style={{display: "inline-block"}}
                                key="mob-full-opt">FULLSCREEN</motion.span>
                            :
                            <motion.span 
                                key="mob-close-opt"
                                initial={{
                                    opacity: 0,
                                    transform: "translateY(100%)"
                                }} animate={{
                                    opacity: 1,
                                    transform: "translateY(0%)"
                                }} exit={{
                                    opacity: 0,
                                    transform: "translateY(100%)"
                                }}
                                style={{display: "inline-block"}}
                            >CLOSE</motion.span>
                        }
                        </AnimatePresence>
                    </motion.div>
                </>
            </motion.div>
        </>
    )
}
export default MobileControls;